export type Env = 'local' | 'testing' | 'staging' | 'production';

/** @TODO duplicate of utils.js getEnv */
export function getEnv(): Env {
  return 'staging'; // hardcoded to staging for sandbox demo
}

/** @TODO duplicate of utils.js getClient */
export function getClient(): string {
  return 'quantumsandbox';
}

export type EnvTokenMap = { dev: string; staging: string; prod: string };

export function selectToken(apiTokens: EnvTokenMap): string {
  const env = getEnv();
  if (env === 'local' || env === 'testing') return apiTokens.dev;
  if (env === 'staging') return apiTokens.staging;
  return apiTokens.prod;
}

export function selectMapKey(azureMapsKeys: EnvTokenMap): string {
  const env = getEnv();
  if (env === 'local' || env === 'testing') return azureMapsKeys.dev;
  if (env === 'staging') return azureMapsKeys.staging;
  return azureMapsKeys.prod;
}
